import * as yup from 'yup';

export const ContasReceberSchema = yup.object().shape({
  valor: yup.number()
    .required('Campo Obrigatorio!')
    .min(1, 'Valor deve ser maior que zero'),
  condicao_parcelamento: yup.number()
    .required('Campo Obrigatorio!'),
  cliente: yup.object()
    .required('Campo Obrigatorio!'),
  vencimento: yup.date()
    .required('Campo Obrigatorio!')
    .min(new Date(-1), 'Data deve ser maior ou igual a data atual'),
});
